// extracted by mini-css-extract-plugin
export var buttonshadow = "styles-module--buttonshadow--161f5";
export var chatbutton = "styles-module--chatbutton--36c5c";
export var chatdialog = "styles-module--chatdialog--68b7d";
export var chatdialogagentoptions = "styles-module--chatdialogagentoptions--5ccca";
export var chatdialogagentoptionsholder = "styles-module--chatdialogagentoptionsholder--7e91f";
export var chatdialogcontent = "styles-module--chatdialogcontent--3a863";
export var chatdialogcontentmsg = "styles-module--chatdialogcontentmsg--8191e";
export var chatdialogcontentmsgaligner = "styles-module--chatdialogcontentmsgaligner--41b75";
export var chatdialogcontentmsgbuttonoption = "styles-module--chatdialogcontentmsgbuttonoption--330e8";
export var chatdialogcontentmsgholder = "styles-module--chatdialogcontentmsgholder--6283c";
export var chatdialogcontentmsgtypebot = "styles-module--chatdialogcontentmsgtypebot--70069";
export var chatdialogcontentmsgtypesystem = "styles-module--chatdialogcontentmsgtypesystem--9f9ca";
export var chatdialogcontentmsgtypeuser = "styles-module--chatdialogcontentmsgtypeuser--a36cc";
export var chatdialogheading = "styles-module--chatdialogheading--6507e";
export var chatdialogsubmitarea = "styles-module--chatdialogsubmitarea--42df2";
export var chatdialogsubmitareabutton = "styles-module--chatdialogsubmitareabutton--7ba5a";
export var headingButtons = "styles-module--headingButtons--1e0c0";
export var mainholder = "styles-module--mainholder--4ceed";
export var mainholderexpanded = "styles-module--mainholderexpanded--08641";
export var removebutton = "styles-module--removebutton--4dc72";
export var roundedcorner = "styles-module--roundedcorner--8ee16";